import { useMutationData } from "./useMutationData";

export const useDashboard = () => {
  // Dashboard vulnerability status API
  const vulnerabilityStatusMutation = useMutationData(
    "/dashboard_vulnerability_status",
    { method: "POST" },
    {
      onSuccess: () => {},
      onError: (error) => {
        console.error("Error fetching vulnerability status:", error);
      },
    }
  );

  // Dashboard status API
  const dashboardStatusMutation = useMutationData(
    "/dashboard_status",
    { method: "POST" },
    {
      onSuccess: () => {},
      onError: (error) => {
        console.error("Error fetching dashboard status:", error);
      },
    }
  );

  // Dashboard requests API
  const dashboardRequestsMutation = useMutationData(
    "/dashboard_requests",
    { method: "POST" },
    {
      onSuccess: () => {},
      onError: (error) => {
        console.error("Error fetching dashboard requests:", error);
      },
    }
  );

  // Function to fetch all dashboard data
  const fetchDashboardData = async (productSeqs = null, dateFrom = null, dateTo = null) => {
    const requestBody = {
      productSeqs,
      dateFrom,
      dateTo
    };

    try {
      // Call all three APIs in parallel
      const [vulnerabilityData, statusData, requestsData] = await Promise.all([
        vulnerabilityStatusMutation.mutateAsync(requestBody),
        dashboardStatusMutation.mutateAsync(requestBody),
        dashboardRequestsMutation.mutateAsync(requestBody)
      ]);

      return {
        vulnerabilityData,
        statusData,
        requestsData
      };
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      throw error;
    }
  };

  return {
    // Individual mutations
    vulnerabilityStatusMutation,
    dashboardStatusMutation,
    dashboardRequestsMutation,
    
    // Combined fetch function
    fetchDashboardData,
    
    // Loading states
    isLoading: vulnerabilityStatusMutation.isPending || dashboardStatusMutation.isPending || dashboardRequestsMutation.isPending,
    
    // Error states
    error: vulnerabilityStatusMutation.error || dashboardStatusMutation.error || dashboardRequestsMutation.error
  };
};